import React, {Fragment} from 'react';

import {useWindowSize, constants} from '@newsela/angelou';
import classNames from 'classnames/bind';
import {capitalize, upperCase} from 'lodash-es';
import PropTypes from 'prop-types';

import {CLASSNAME_FOR_JEEVES_GLOBAL_NAV_SUGGESTION} from 'static/three-oh/src/routes/Search/constants';
import {toSnakeCase} from 'static/three-oh/utils/stringUtils';

import styles from './styles.js';

const generateClassNames = classNames.bind(styles);

const GlobalNavSearchSuggestionsSection = (props) => {
  const {header, listItems, ariaLabel, dataQaSelector} = props;

  return (
    <section>
      {header}
      <ul
        className={styles.suggestionList}
        aria-label={ariaLabel}
        data-qa-selector={dataQaSelector}
      >
        {listItems}
      </ul>
    </section>
  );
};

GlobalNavSearchSuggestionsSection.propTypes = {
  header: PropTypes.node.isRequired,
  listItems: PropTypes.node.isRequired,
  ariaLabel: PropTypes.string.isRequired,
  dataQaSelector: PropTypes.string.isRequired,
};

const SectionHeader = (props) => {
  return (
    <h3 className={styles.header} data-qa-selectors="suggested_searches_title">
      {upperCase(props.headerTitle)}
    </h3>
  );
};

SectionHeader.propTypes = {
  headerTitle: PropTypes.string.isRequired,
};

const GlobalNavSearchSuggestion = (props) => {
  const {
    isSelected,
    onClick,
    onKeyDown,
    suggestionText,
    standardTitle,
    grade,
    region,
    isStandard,
  } = props;

  const {width: windowWidth} = useWindowSize();
  const {
    breakpoints: {
      Breakpoints: {sm},
    },
  } = constants;
  const isMobile = windowWidth < sm;
  const suggestion = isStandard ? (
    <>
      <div className={styles.standardDescriptionRow}>
        <div className={styles.standardTitle}>{standardTitle}</div>
        <div>{`${grade} (${region})`}</div>
      </div>
      {capitalize(suggestionText)}
    </>
  ) : (
    capitalize(suggestionText)
  );
  const suggestionClassNames = generateClassNames({
    suggestion: true,
    standardSuggestion: isStandard,
    mobileStandardSuggestion: isStandard && isMobile,
  });

  return (
    <li
      key={suggestionText}
      tabIndex={0}
      className={CLASSNAME_FOR_JEEVES_GLOBAL_NAV_SUGGESTION}
      onKeyDown={onKeyDown}
    >
      <a
        aria-selected={isSelected}
        className={suggestionClassNames}
        data-qa-selector={`${toSnakeCase(suggestionText)}_suggestion`}
        onClick={onClick}
        role="option"
      >
        {suggestion}
      </a>
    </li>
  );
};

GlobalNavSearchSuggestion.propTypes = {
  isSelected: PropTypes.bool,
  onClick: PropTypes.func.isRequired,
  onKeyDown: PropTypes.func.isRequired,
  suggestionText: PropTypes.string.isRequired,
  region: PropTypes.array,
  grade: PropTypes.string,
  isStandard: PropTypes.bool,
  standardTitle: PropTypes.string,
};

GlobalNavSearchSuggestion.defaultProps = {
  isStandard: false,
};

const GlobalNavMenuDivider = () => {
  return <div className={styles.divider} />;
};

export {
  GlobalNavSearchSuggestionsSection,
  SectionHeader,
  GlobalNavSearchSuggestion,
  GlobalNavMenuDivider,
};
